// extracted by mini-css-extract-plugin
export default {"root":"IntroText_root__VoV4e","content":"IntroText_content__Bav77","readMoreButton":"IntroText_readMoreButton__tgHoV","arrow":"IntroText_arrow__eN+jY"};